import { Component, OnInit, ViewChild } from '@angular/core';
import { PointService } from 'src/app/services/point.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Voucher } from 'src/app/models/point';
import { RedeemPopupComponent } from '../redeem-popup/redeem-popup.component';

@Component({
  selector: 'app-detail-voucher',
  templateUrl: './detail-voucher.component.html',
  styleUrls: ['./detail-voucher.component.css']
})
export class DetailVoucherComponent implements OnInit {

  public voucher: Voucher;
  @ViewChild('redeemModal') redeemModal: RedeemPopupComponent;

  constructor(
    private pointService: PointService,
    private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.getVoucherDetail();
  }

  getVoucherDetail() {
    const data = this.route.snapshot.paramMap.get('data');
    if (data != null) {
      this.voucher = JSON.parse(atob(data));
    } else {
      this.router.navigate(['point']);
    }
  }

  public redeemVoucher(voucher: Voucher): void {
    this.redeemModal.showVoucher(voucher);
  }
}
